/* global G */
import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import Text from 'ui/Element/Text'
import { useContext } from 'react'
import ApplicationContext from 'platform/react/context/application'
import { getSubLabel, makeBreakable } from 'lib/util/string'
import find from 'lib/sequence/component/children/find'
import StatusChip from 'ui/Element/Text/StatusChip'

const styles = () => ({
  subLabel: {
    gap: '0.25rem',
  },
  container: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
})

/**
 * Displays information about a request.
 *
 * @param {Object} classes  element's style classes
 * @param {Object} props    element's properties
 *
 * @returns {JSX.Element}
 */
const ListItemCellRequestInformation = (classes, props = {}) => {
  const { intl, session: { [G.MODULE]: module } = {} } = useContext(ApplicationContext)
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const { list } = find(actionComponent)
  const { suppressServiceItem = false } = list[G.STATE] || {}

  const {
    withStatus = true,
    withDevice = true,
    withDescription = true,
    withCreated = true,

    createdLabel,
    number,

    inverse = false,
    itemData: { name = null, serial = null } = {},

    status: statusKey,
    description: { text: description = null } = {},

    submit: { timestamp: submitTimestamp = '' } = {},
    modify: { timestamp: modifyTimestamp = '' } = {},
    events,
  } = props

  const onOpen = events.getStatus || events.getRequestStatus

  const createdDate = intl.getLocaleDate(submitTimestamp, { dateStyle: 'short' })
  const createdString = getSubLabel(Text, [createdLabel, createdDate])
  const deviceString = getSubLabel(Text, inverse ? [serial, name] : [name, serial])

  return (
    <Grid
      container
      className={classes.container}
    >
      {withStatus && onOpen && (
        <Grid
          item
          xs={'auto'}
        >
          <StatusChip
            size={'tiny'}
            shape={'rounded'}
            value={statusKey}
            events={{ onOpen }}
          />
        </Grid>
      )}
      <Grid
        container
        gap={'0.125rem'}
        direction={'column'}
        alignItems={'flex-start'}
        justifyContent={'center'}

        sx={{ height: '100%' }}
      >
        <Grid
          item
          xs={'auto'}
          component={Text}

          value={number}
          variant={'14/bold'}
          color={'black.main'}
        />
        {withDescription && description && (
          <Grid
            item
            xs={'auto'}
            component={Text}

            maxLines={1}
            color={'gray.400'}
            variant={'14/medium'}
            value={makeBreakable(description)}
          />
        )}
        {withDevice && deviceString?.length && !suppressServiceItem ? (
          <Grid
            item
            xs={'auto'}
            component={Text}
            value={deviceString}
            variant={'14/regular'}
            className={classes.subLabel}
          />
        ) : <></>}
        {withCreated && createdLabel && createdDate && (
          <Grid
            item
            container
            xs={'auto'}
            className={classes.subLabel}
          >
            {createdString}
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}

export default CellHOC(ListItemCellRequestInformation, styles)
